import type { HandleInputChange } from "./types";

type RangeInputProps = {
    name: string;
    value?: string | number;
    min?: number;
    max?: number;
    step?: number;
    onChange: HandleInputChange;
};

const RangeInput = ({ name, value = "0", min, max, step, onChange }: RangeInputProps) => {
    const rangeValue = value;

    return (
        <input
            type="range"
            className="form-range"
            name={name}
            value={rangeValue as string | number}
            min={min}
            max={max}
            step={step}
            onChange={(event) => onChange(event, name, event.target.value)}
        />
    );
};

export default RangeInput;
